export default __webpack_public_path__ + "static/char-s-02-kr-76261dd658a532e2c13ffa9fe735136d.png";